module.exports = __webpack_public_path__ + "static/media/PSIFooter.c5e41060.png";